export default {
	methods: {
		parseValue(value) {
			let parsedValue;

			if (value !== null && value !== undefined) {
				switch (this.attrs.type) {
					case 'date':
					case 'datetime':
						parsedValue = this.dateParseValue(value);
						break;

					case 'time':
						parsedValue = this.timeParseValue(value);
						break;

					case 'relation':
						parsedValue = this.relationParseValue(value);
						break;

					case 'select':
						parsedValue = this.selectParseValue(value);
						break;

					case 'user':
						parsedValue = this.userParseValue(value);
						break;

					case 'integer':
						parsedValue = this.numberIntParseValue(value);
						break;

					case 'double':
						parsedValue = this.numberDecParseValue(value);
						break;

					case 'boolean':
						parsedValue = this.booleanParseValue(value);
						break;

					default:
						parsedValue = value;
				}
			}

			return parsedValue;
		},
		parseDefaultValue() {
			switch (this.attrs.type) {
				case 'relation':
					return this.relationParseDefaultValue();

				case 'select':
					return this.selectParseDefaultValue();

				case 'user':
					return this.userParseDefaultValue();

				case 'date':
				case 'datetime':
				case 'time':
					return this.dateParseDefaultValue();

				case 'integer':
				case 'double':
					return this.numberParseDefaultValue();

				case 'boolean':
					return this.booleanParseDefaultValue();

				case 'text': case 'textarea':
					return this.textParseDefaultValue();

				default:
					return null;
			}
		}
	}
};
